<rid-correct-answer-modal (continue)="continue.emit()">
  <div class="grid gap-4 text-left">
    <div class="grid gap-6 rounded-md border-2 border-dashed border-slate-300 p-4">
      @switch (rule()) {
        @case ('SPLIT_AFTER_MULTITEKEN_KLANK') {
          <p class="text-center text-2xl font-medium">Bij een 2-, 3- of 4-tekenklank splits je het woord na deze klank.</p>

          <div class="grid gap-2">
            <p class="text-text-secondary text-center text-sm">Voorbeelden</p>
            <div class="flex justify-center gap-4">
              <rid-audio-button [src]="{ pronounce: 'boeken' }" size="SMALL" />
              <rid-audio-button [src]="{ pronounce: 'mooie' }" size="SMALL" />
              <rid-audio-button [src]="{ pronounce: 'leeuwen' }" size="SMALL" />
            </div>
          </div>
        }
        @case ('SPLIT_BEFORE_CENTRAL_CONSONANT') {
          <p class="text-center text-2xl font-medium">
            Hoor je één medeklinker in het midden van het woord?
            <br />
            Splits dan vóór de medeklinker.
          </p>

          <div class="grid gap-2">
            <p class="text-text-secondary text-center text-sm">Voorbeelden</p>
            <div class="flex justify-center gap-4">
              <rid-audio-button [src]="{ pronounce: 'lopen' }" size="SMALL" />
              <rid-audio-button [src]="{ pronounce: 'water' }" size="SMALL" />
              <rid-audio-button [src]="{ pronounce: 'tafel' }" size="SMALL" />
            </div>
          </div>
        }
        @case ('SPLIT_BETWEEN_CONSONANTS') {
          <p class="text-center text-2xl font-medium">
            Hoor je twee medeklinkers in het midden van het woord?
            <br />
            Splits dan tussen de medeklinkers.
          </p>

          <div class="grid gap-2">
            <p class="text-text-secondary text-center text-sm">Voorbeelden</p>
            <div class="flex justify-center gap-4">
              <rid-audio-button [src]="{ pronounce: 'winter' }" size="SMALL" />
              <rid-audio-button [src]="{ pronounce: 'panda' }" size="SMALL" />
              <rid-audio-button [src]="{ pronounce: 'wortel' }" size="SMALL" />
            </div>
          </div>
        }
      }

      <rid-klankvoet-rule-glyph class="text-3xl text-slate-500" [rule]="rule()" />
    </div>

    <div class="flex items-center gap-4 rounded-md bg-red-100 p-3 text-red-600">
      <svg class="size-14 shrink-0" viewBox="0 0 24 24" aria-hidden="true">
        <path class="fill-red-600" d="M12 2 23 21H1Z" />
        <path class="fill-white" d="M10.8 8h2.4l-.4 7h-1.6ZM12 16.2a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6Z" />
      </svg>
      <p>Het gaat om wat je hoórt, niet om hoe je het woord schrijft, want het gaat om klankvoeten en niet om lettergrepen.</p>
    </div>
  </div>
</rid-correct-answer-modal>
